"use strict";
exports.__esModule = true;
function asyncify(syncFunction) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return new Promise(function (resolve, reject) {
        try {
            var result = syncFunction.apply(void 0, args);
            resolve(result);
        }
        catch (error) {
            reject(error);
        }
    });
}
exports["default"] = asyncify;
